import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=643117d7&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=643117d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643117d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643117d7')) {
      api.createRecord('643117d7', component.options)
    } else {
      api.reload('643117d7', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=643117d7&scoped=true&", function () {
      api.rerender('643117d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bz3z9Xm55MeJ/JS/teamMember.vue"
export default component.exports